import { formatNumber, formatDate } from "devextreme/localization"

export default (app) => {
    return {
        formatTime(valor, format) {
            if (!valor || !format)
                return valor
            const [ horas = 0, minutos = 0, segundos = 0, milissegundos = 0 ] = valor.split(':')
            switch (format.type) {
                case 'millisecond': return milissegundos
                case 'second': return segundos
                case 'minute': return minutos
                case 'hour': return horas
                case 'shortTime': return `${horas}:${minutos}`
                case 'longTime': return `${horas}:${minutos}:${segundos}`
                default: valor
            }
        },
        setaValorVariavel(campoFonte, dados, variavel) {

            let processaFuncaoQueRequerMassaDeDadosCompleta = (funcao) => {
                if(!variavel.painelVariavelFonteDados.argumentField)
                    return;
                variavel.valor = 0;
                //Função groupByFunction ao usar sum e avg pode retornar nullo, caso de algum problema considerar o contexto dessa tarefa #124448 e olhar a explicação do commit c91ad55cc7f1b3b7eaf9d7bfc7d09910e745cd0d
                var res = app.config.globalProperties.$vistra.groupByFunction(dados, //massa de dados completa
                                                                variavel.painelVariavelFonteDados.argumentField.toLocaleLowerCase(), //campo argumento
                                                                campoFonte.campo.toLocaleLowerCase(), //campo valor
                                                                funcao);
                res = res.find(r => r[variavel.painelVariavelFonteDados.argumentField.toLocaleLowerCase()] == variavel.painelVariavelFonteDados.argumentValue);
                if (res != undefined)
                    variavel.valor = res[campoFonte.campo.toLocaleLowerCase()];
            }

            let formatacao = app.config.globalProperties.$vistra.getFormatacaoDev(variavel.painelVariavelFonteDados.formatacao?.type ? variavel.painelVariavelFonteDados?.formatacao : campoFonte?.formatacao)
            if (!formatacao && !formatacao?.type)
                formatacao = null
            let funcaoPadrao = (variavel.painelVariavelFonteDados.funcaoPadrao || "").toLocaleLowerCase()

            //Tarefa #119288 os dados podem vir nulo devido a correção dessa tarefa. Se essa validação der problema no futuro alterar considerando o contexto da tarefa #119288
            if (!!dados && dados.length > 1) {
                if (app.config.globalProperties.$vistra.Expression.getDataTypeByTipoCampo(campoFonte.tipo) === "number") {
                    switch (funcaoPadrao) {
                        case "sum":
                            variavel.valor = app.config.globalProperties.$vistra.sum(dados, campoFonte.campo.toLocaleLowerCase())
                            break;
                        case "avg":
                            variavel.valor = app.config.globalProperties.$vistra.avg(dados, campoFonte.campo.toLocaleLowerCase())
                            break;
                        case "max":
                            variavel.valor = app.config.globalProperties.$vistra.max(dados, campoFonte.campo.toLocaleLowerCase())
                            break;
                        case "min":
                            variavel.valor = app.config.globalProperties.$vistra.min(dados, campoFonte.campo.toLocaleLowerCase())
                            break;
                        case "count":
                            variavel.valor = app.config.globalProperties.$vistra.count(dados, campoFonte.campo.toLocaleLowerCase())
                            break;
                        case "distinct":
                            variavel.valor = app.config.globalProperties.$vistra.distinct(dados, campoFonte.campo.toLocaleLowerCase())
                            break;
                        case "first":
                            variavel.valor = app.config.globalProperties.$vistra.getFuncoesFonteDados(() => dados).First(campoFonte.campo.toLocaleLowerCase());
                            break;
                        case "last":
                            variavel.valor = app.config.globalProperties.$vistra.getFuncoesFonteDados(() => dados).Last(campoFonte.campo.toLocaleLowerCase());
                            break;
                        case 'acc':
                            processaFuncaoQueRequerMassaDeDadosCompleta('acc');
                            break;
                        case 'diffprevious':
                            processaFuncaoQueRequerMassaDeDadosCompleta('diffPrevious');
                            break;
                        case 'diffprevious%':
                            processaFuncaoQueRequerMassaDeDadosCompleta('diffPrevious%');
                            break;
                        case 'perctotal':
                            processaFuncaoQueRequerMassaDeDadosCompleta('percTotal');
                            break;
                        case 'noduplicate':
                                variavel.valor = [...new Set(dados.map(d => d[campoFonte.campo.toLocaleLowerCase()]))]
                                                .sort(function(a, b) {
                                                    return (a > b) ? 1 : ((a < b) ? -1 : 0);
                                                })
                                break;
                        default:
                            variavel.valor = dados.map(d => d[campoFonte.campo.toLocaleLowerCase()])
                            break;
                    }

                    //pós processamento
                    if (formatacao) {
                        switch (funcaoPadrao) {
                            case "sum":
                            case "avg":
                            case "max":
                            case "min":
                            case "first":
                            case "last":
                            case "count":
                            case 'acc':
                            case 'diffprevious':
                            case 'diffprevious%':
                            case 'perctotal':
                                if (app.config.globalProperties.$vistra.Expression.getDataTypeByTipoCampo(campoFonte.tipo) === "number")
                                    variavel.valorFormatado = formatNumber(variavel.valor, formatacao)
                                break;
                            default:
                            case "distinct":
                            case 'noduplicate':
                                variavel.valorFormatado = variavel.valor.map(valor => formatNumber(valor, formatacao))
                                break;
                        }
                    }
                }
                else { //variaveis nao numericas
                    if (campoFonte.tipo === "TIME" && (funcaoPadrao == "sum" || funcaoPadrao == "avg")) {
                        variavel.valor = app.config.globalProperties.$vistra[funcaoPadrao+'Time'](dados, campoFonte.campo.toLocaleLowerCase())
                    } else {
                        switch (funcaoPadrao) {                                
                            case "max":
                                variavel.valor = app.config.globalProperties.$vistra.max(dados, campoFonte.campo.toLocaleLowerCase())
                                break;
                            case "min":
                                variavel.valor = app.config.globalProperties.$vistra.min(dados, campoFonte.campo.toLocaleLowerCase())
                                break;
                            case "count":
                                variavel.valor = app.config.globalProperties.$vistra.getFuncoesFonteDados(() => dados).Count(); //count(dados, campoFonte.campo.toLocaleLowerCase())
                                break;
                            case "distinct":
                                variavel.valor = app.config.globalProperties.$vistra.getFuncoesFonteDados(() => dados.map(d => d[campoFonte.campo.toLocaleLowerCase()])).Distinct();
                                break;
                            case "first":
                                variavel.valor = app.config.globalProperties.$vistra.getFuncoesFonteDados(() => dados).First(campoFonte.campo.toLocaleLowerCase());
                                break;
                            case "last":
                                variavel.valor = app.config.globalProperties.$vistra.getFuncoesFonteDados(() => dados).Last(campoFonte.campo.toLocaleLowerCase());
                                break;
                            case 'noduplicate':
                                variavel.valor = [...new Set(dados.map(d => d[campoFonte.campo.toLocaleLowerCase()]))]
                                                    .sort(function(a, b) {
                                                        return (a > b) ? 1 : ((a < b) ? -1 : 0);
                                                    })
                                break;
                            default:
                                variavel.valor = dados.map(d => d[campoFonte.campo.toLocaleLowerCase()])
                                break;
                        }
                    }
                    //pós processamento
                    if (formatacao && ["date", "datetime", "time"].includes(app.config.globalProperties.$vistra.Expression.getDataTypeByTipoCampo(campoFonte.tipo))) {
                        switch (funcaoPadrao) {
                            case "count":
                                break;
                            case "distinct":
                            case 'noduplicate':
                                variavel.valorFormatado = variavel.valor.map(valor => {
                                    if (!valor)
                                        return valor
                                    if ((typeof valor == 'string') && campoFonte.tipo === "TIME")
                                        return this.formatTime(valor, formatacao)
                                    return formatDate(new Date(valor), formatacao)
                                })
                                break;
                            default:
                                if (variavel.valor) {
                                    if ((typeof variavel.valor == 'string') && campoFonte.tipo === "TIME")
                                        variavel.valorFormatado = this.formatTime(variavel.valor, formatacao)
                                    else {
                                        let descontroi = {...variavel.valor}
                                        let valor = descontroi > 1 ? descontroi : variavel.valor;
                                        if(valor.length > 1){
                                            variavel.valorFormatado = formatDate(...valor, formatacao)
                                        }else {
                                            variavel.valorFormatado = formatDate(valor, formatacao)
                                        }
                                    }
                                }
                                break;
                        }
                    }
                }
            }
            //Tarefa #119288 os dados podem vir nulo devido a correção dessa tarefa. Se essa validação der problema no futuro alterar considerando o contexto da tarefa #119288
            else if (!!dados && dados.length === 1) {
                if (funcaoPadrao == 'count')
                    variavel.valor = dados[0][campoFonte.campo.toLocaleLowerCase()] != null ? 1 : 0
                else
                    variavel.valor = dados[0][campoFonte.campo.toLocaleLowerCase()]

                if (formatacao) {
                    switch (campoFonte.tipo) {
                        case "DATE":
                        case "TIME":
                        case "DATETIME":
                            variavel.valorFormatado = formatDate(variavel.valor,  formatacao)
                            break;
                        case "DOUBLE":
                        case "INTEGER":
                            variavel.valorFormatado = formatNumber(variavel.valor,  formatacao)
                            break;
                    }
                }
            } else {
                variavel.valor = undefined
            }
        }
    }
}